// Pure helpers behind Predict's outcomes (STRY0038978). The page reads
// GET /predict/outcomes; each outcome is {vendor, bugId, title, url, score,
// promoted, frozenAt, cve, class, firstPublicAt, leadDays, target, targetName}.
// Dates, scores and links use the watch list's helpers (predictWatchlistModel).

// The two classes a customer sees, in Eric's words. ODD publishes only these
// (a reviewer classed and confirmed them) and the API keeps only these; any
// other class is never shown, let alone unlabelled.
export const CLASS_LABEL = { predicted: 'Prediction', 'retro-matched': 'Detection' };

export const CLASSES = Object.keys(CLASS_LABEL);

export const classLabel = cls =>
  typeof cls === 'string' && Object.prototype.hasOwnProperty.call(CLASS_LABEL, cls) ? CLASS_LABEL[cls] : null;

const isText = value => typeof value === 'string' && value.trim() !== '';

// The outcomes the page can show: a bug, a CVE and a known class each.
export const visibleOutcomes = outcomes =>
  Array.isArray(outcomes)
    ? outcomes.filter(o => o && isText(o.vendor) && isText(o.bugId) && isText(o.cve) && classLabel(o.class))
    : [];

// The count of each class on its own. The counting rule reports Prediction and
// Detection separately and never adds them, so there is no combined total.
export const classCounts = outcomes =>
  Object.fromEntries(CLASSES.map(cls => [cls, outcomes.filter(o => o.class === cls).length]));

export const filterByClass = (outcomes, cls) => (cls ? outcomes.filter(o => o.class === cls) : outcomes);

// The lead is whole days from the freeze to the first public statement, as ODD
// works it out. Null when ODD doesn't know either date. Negative when the
// statement came first (ODD rounds down, so an hour before reads one day),
// which reads as days before the freeze rather than as a minus sign.
export const formatLead = days => {
  if (!Number.isInteger(days)) return '—';
  const n = Math.abs(days);
  const text = `${n} ${n === 1 ? 'day' : 'days'}`;
  return days < 0 ? `${text} before the freeze` : text;
};

const CVE_ID = /^CVE-\d{4}-\d{4,7}$/;

// The CVE's public record. Only a well-formed id becomes a link.
export const cveUrl = cve => {
  const id = typeof cve === 'string' ? cve.trim() : '';
  return CVE_ID.test(id) ? `https://www.cve.org/CVERecord?id=${id}` : null;
};

// A bug can become more than one CVE, so a row is one bug and one CVE.
export const outcomeKey = o => `${o.vendor}\u0000${o.bugId}\u0000${o.cve}`;
